import React from 'react'
import Layout from "../components/layout"



const AboutPage = () => {
    return (
        
        <div>
            <h1>About Us</h1>
            <p>
                  lorem       </p>
        </div>
        
    )
}

export default AboutPage;
